import './styles/styles.css';
import './styles/social.css';
import Particles from './components/particles.js';
import PageRouter from "./components/router.js";
import { Router, Link, useLocation } from "wouter";
 
function App() {
  return (
    <Router>
        <div className="App">
            <header className="App-header">
                <nav>
                    <a href='https://grimmxiii.com/account'><div class="loginButton" >
                        <img src='default.png' className='navLogin' />    
                    </div></a>

                    <a href="https://grimmxiii.com">
                        <div class="navButton active" >
                            <a className='title1'>Go to my Main Website!</a>
                            <a className='title2'>Why screen so smol?</a>
                        </div>
                    </a>
                </nav>
            </header>
            <PageRouter />
            <Particles id="tsparticles" />
            <footer>
                <img src="lilgrim.png" id="lilgrim"/>
                <br/>
                Thanks for stoppin by! -GrimmXIII :)
            </footer>
        </div>
    </Router>
    
  );
}

export default App;
